<app-header class="e11-fixed e11-w-full e11-z-[2] e11-top-0"></app-header>

<main class="layout-main">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
<e11-backdrop></e11-backdrop>
